import React, { useEffect, useState } from 'react';
import { Form, Modal, Input } from 'antd';
import styles from './notes.module.sass';
import { useDispatch, useSelector } from 'react-redux';
import { createIOCNote } from '../../../../redux/actions/ioc';
import { updateIOCNote } from '../../../../redux/actions/ioc';

export function NoteAddEdit({
  isEditing,
  noteUUID,
  description,
  iocUUID,
  feedUUID,
  isVisible,
  setModalVisibility,
}) {
  const dispatch = useDispatch();
  const [noteDescription, setNoteDescription] = useState(description);
  const [charactersAllowed, setCharactersAllowed] = useState(255);
  useEffect(() => {
    if (!noteDescription) {
      setCharactersAllowed(255);
    } else {
      setCharactersAllowed(255 - noteDescription.length);
    }
  }, [noteDescription]);

  const saveNote = () => {
    if (isEditing) {
      dispatch(updateIOCNote(iocUUID, noteUUID, noteDescription));
    } else {
      dispatch(createIOCNote(noteDescription, iocUUID, feedUUID));
    }
    setModalVisibility(false);
  };

  return (
    <Modal
      okText={'Save'}
      onCancel={() => setModalVisibility(false)}
      destroyOnClose={true}
      okButtonProps={{
        disabled: !!!noteDescription?.trim(),
      }}
      onOk={() => saveNote()}
      title={isEditing ? 'Edit note' : 'Add note'}
      visible={isVisible}
    >
      <Form
        name="note-description"
        initialValues={{ description: description }}
        layout={'vertical'}
      >
        <Form.Item
          className={styles['note-description-form-item']}
          name="description"
          label="Note description"
          // initialValue={noteDescription}
          style={{ marginBottom: 0 }}
          rules={[{ required: true, message: 'Enter description' }]}
        >
          <Input.TextArea
            onChange={(e) => setNoteDescription(e.target.value)}
            style={{
              height: 104,
            }}
            maxLength={255}
          />
        </Form.Item>
        <span
          style={{
            display: 'inline-block',
            margin: '8px 0 0 8px',
            color: 'rgba(255, 255, 255, 0.45)',
          }}
        >
          {charactersAllowed} characters allowed
        </span>
      </Form>
    </Modal>
  );
}
